import React, { useState } from 'react';
import BigHeader from "../../components/BigHeader";
import CardContainer from '../../components/CardContainer';
import FlowChart from '../../components/FlowChart';
import TextBlockComponent from '../../components/TextBlockComponent';
import { Container, Row, Col, ListGroup, Card } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Accordion from 'react-bootstrap/Accordion';
import Carousel from 'react-bootstrap/Carousel';
import DesignPrinciplesHumanPractices from './DesignPrinciples';

function DesignPrinciples() {
  return (
    <Container>
      <h1 id="design-principles-and-key-take-aways" style={{marginTop: '53px', marginBottom: '32px'}}>Design principles and key take-aways</h1>
      <Row>
        <Col>
          <h2 id="-what-we-learnt-">
            <strong>What we learnt:</strong>
          </h2>
          <Card>
            <Card.Body>
              <strong>From community:</strong>
              <ListGroup variant="flush">
                <ListGroup.Item>Product must be designed in a way that is non-stigmatizing, pleasure-focused.</ListGroup.Item>
                <ListGroup.Item>Medical aim and therapeutic strategy must be explicited nonetheless to build trust in the product.</ListGroup.Item>
                <ListGroup.Item>User-centric product: user-friendly, agreeable, sleek, and elegant.</ListGroup.Item>
                <ListGroup.Item>Services provided with the product must be friendly, easily digestible, and rely on common language.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body>
              <strong>From medical & public health professionals:</strong>
              <ListGroup variant="flush">
                <ListGroup.Item>Promotion of the product must not undermine other preventative and therapeutic strategies.</ListGroup.Item>
                <ListGroup.Item>Product fits into primary care & preventative, combination prevention, universal health care.</ListGroup.Item>
                <ListGroup.Item>Reaching out to communities through their preferred mode of communication is a viable strategy.</ListGroup.Item>
                <ListGroup.Item>
                  Specific accessibility take-ways:
                  <ListGroup>
                    <ListGroup.Item>Men who have sex with men: providing an option for peaceful unthinking of the threat of illness is a plus.</ListGroup.Item>
                    <ListGroup.Item>Women: Lubritect provides women with an empowering protection medium.</ListGroup.Item>
                    <ListGroup.Item>Older women: Lubritect potentially a solution to menopausal related issues.</ListGroup.Item>
                    <ListGroup.Item>Sex workers: look out for perverse outcomes.</ListGroup.Item>
                  </ListGroup>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body>
              <strong>From scientists:</strong>
              <ListGroup variant="flush">
                <ListGroup.Item>An in-depth understanding of the molecular mechanisms should be sought after.</ListGroup.Item>
                <ListGroup.Item>We must think about viral evolution.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
          <Card>
            <Card.Body>
              <strong>From entrepreneurship experts:</strong>
              <ListGroup variant="flush">
                <ListGroup.Item>Ease-of-use & design key components of success uptake.</ListGroup.Item>
                <ListGroup.Item>Medical device with medicinal property: recognize the product’s therapeutic power.</ListGroup.Item>
                <ListGroup.Item>Pricing, benchmarking & market access in accordance with the added value.</ListGroup.Item>
                <ListGroup.Item>The planet is one of our stakeholders.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <h2 id="-what-we-did-">
            <strong>What we did:</strong>
          </h2>
          <Card>
            <Card.Body>
              <ListGroup variant="flush">
                <ListGroup.Item>Conceptualized and developed scientific proof of concepts that addressed users' fears and needs.</ListGroup.Item>
                <ListGroup.Item>Conceptualized and developed a product that met all the mentioned criteria.</ListGroup.Item>
                <ListGroup.Item>Conceptualized and developed services that go with it.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <h2 id="-what-we-ll-do-">
            <strong>What we'll do:</strong>
          </h2>
          <Card>
            <Card.Body>
              <h3 id="scientific-aspects">Scientific aspects</h3>
              <ListGroup variant="flush">
                <ListGroup.Item>Devise fluid dynamic experiments of GFP tagged T4 in mucin solutions.</ListGroup.Item>
                <ListGroup.Item>Design and test binders for HPV L1 proteins.</ListGroup.Item>
                <ListGroup.Item>Plan and set up experiments on cell lines and reconstructed mucosa.</ListGroup.Item>
                <ListGroup.Item>Visualize and quantify the disruption of viral cell entry.</ListGroup.Item>
                <ListGroup.Item>Test the effects of the lubricant on vaginal microbiota.</ListGroup.Item>
                <ListGroup.Item>Plan feasibility and pilot studies.</ListGroup.Item>
                <ListGroup.Item>According to feasibility studies, plan clinical trials.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <h3 id="production">Production</h3>
              <ListGroup variant="flush">
                <ListGroup.Item>Explore alternative sources of mucin and possibilities of commercial scaling up.</ListGroup.Item>
                <ListGroup.Item>Aim at the maximal reduction of parts.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <h3 id="product-design">Product design</h3>
              <ListGroup variant="flush">
                <ListGroup.Item>Continuously involve the consumers, request feedback on the product, packaging, language and branding.</ListGroup.Item>
                <ListGroup.Item>Propose diverse packaging options in order to reach out to different age groups.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <h3 id="entrepreneurship">Entrepreneurship</h3>
              <ListGroup variant="flush">
                <ListGroup.Item>Constantly reassess the production pipeline, quality assurance, sales, and feedback from the customers.</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

function HPControlledCarousel({item}) {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex , e) => {
      setIndex(selectedIndex);
  };

  return (
    <Carousel  interval={500000000}  activeIndex={index} onSelect={handleSelect} pause={'hover'} data-bs-theme="dark" >
      <Carousel.Item  > 
      <Container className="text-center" style={{minHeight: "550px"}}>
      <Container style={{maxHeight: "00px"}}>
      <Image  style={{width: 'auto', height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '0px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/stat-1.png'} text="Second slide" />

                     </Container>


          </Container>

      </Carousel.Item>
      <Carousel.Item style={{alignItems:"center"}}> 
      <Container className="text-center" style={{minHeight: "550px"}}>
      <Container style={{maxHeight: "300px"}}>
      <Image  style={{width: 'auto', height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '0px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/stat-2.png'} text="Second slide" />

                     </Container>
          </Container>

      </Carousel.Item>
      <Carousel.Item style={{alignItems:"center"}}> 
      <Container className="text-center" style={{minHeight: "550px"}}>
      <Container style={{maxHeight: "300px"}}>

      <Image  style={{width: 'auto', height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '0px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/stat-3.png'} text="Second slide" />
                     </Container>

          </Container>

      </Carousel.Item>
      <Carousel.Item style={{alignItems:"center"}}> 
      <Container className="text-center" style={{minHeight: "550px"}}>
      <Container style={{maxHeight: "300px"}}>

      <Image  style={{width: 'auto', height: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '20px', marginTop: '0px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/stat-4.png'} text="Second slide" />
                     </Container>

          </Container>

      </Carousel.Item>
    </Carousel>
  );
}
function ourExperience() {
    return (
        <Container>
          <Row>
            <Col>
              <h1 id="human-practice-methodology-">Our human practice methodology:</h1>
              <p>
                How can we develop a medical device in a way that is safe and useful for the communities that need to be served? How do we make sure we are answering a real-world need in the most efficient and effective way, bearing all limitations in mind?
              </p>
              <p>
                Whilst we approached human practices through a <strong>creative</strong> and <strong>holistic</strong> practice, we made sure we kept these <strong>three questions</strong> in mind at all times:
              </p>
              <ol>
                <li>Who are our stakeholders?</li>
                <li>Through the lens of each of these stakeholders, what is our purpose?</li>
                <li>Through the lens of each of these stakeholders, what are our limitations and are there any related leverage points?</li>
              </ol>
              <p>
                If you needed a reminder, a <strong>stakeholder</strong> is defined as a person, group, organization with a <strong>vested interest</strong>, or stake, in the decision making of a given project. <strong>Leverage points</strong> are a classic component of systems thinking linguo: they refer to the places within a <strong>complex system</strong> where a small shift in one thing can produce <strong>big changes</strong> in everything.
              </p>
              <p>
                Browse through this <strong>interactive mapping</strong> of the <strong>research, conversations, and activities</strong> that enabled us to inform our human practices, but also as you’ll see, our entrepreneurial plan. Make sure you explore all available “<strong>bubbles</strong>” to understand our thought process and not miss out on any important information.
              </p>
              <p>
                If you are new to the field of sexual health, you can also download our introductory guide <a href="https://2023.igem.wiki/paris-bettencourt/human-practices">here</a>.
              </p>
            </Col>
          </Row>
        </Container>
      );
}

const Integrated = () => {


    const headline = "Curiosity is a marvellous driver for science. Human practices enables us to understand how our work can be of service to the communities we inhabit, and how these influence the design of our work. "
    
    const cards = [
        {
            head: "SCIENCE & (HEALTH)CARE",
            text: "Conversations and research with scientists and professionals to refine our project outline and devise the best new antiviral lubricant in the field, with the most efficient and convincing proof-of-concept."
        },
        {
            head: "ARTS, ETHICS & POLITICS",
            text: "Creative approaches to reflecting on the ethics and politics of sexual health, through podcasts, movies, books, plays and conversations with professionals, artists included."
        },
        {
            head: "BUSINESS ",
            text: "Interviews with companies excelling in the development of medical devices for advice on our product’s future applications and fruitful exchanges with potential users such as patients and citizens to inform our design from their lived experiences. "
        },
        {
            head: "EDUCATION & OUTREACH:",
            text: "Introducing and promoting scientific topics to general public and feedbacking to the development of our product and communication strategy."
        },
    ]



    const textBlocksComponent = 
    [
        {
            text: ourExperience,
            header: "Our human practice experience",
            image: "https://static.igem.wiki/teams/4602/wiki/images/images/condom.png",
            isImageOnRight: true,
            backgroundColor: null
        },
    ]

    const flyers = [
      {
        header: 'It is still a huge public health issue',
        
      },
      {
        header: 'It is still a huge taboo, whatever our countries of origin (France, India, Egypt, Serbia, Japan…).',

      },
      {
        header: 'Only three IGEM teams have attempted to contribute to this field.'
      }
    ]
    return (
        <div>
            <BigHeader headerText={'Integrated Human Practices '} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/banner.png'}/>
            <p style={{paddingTop: '15px', paddingLeft: '100px', paddingRight: '100px'}} className="fs-2 text-center">{headline}</p>

            <CardContainer cardData={cards}/>
            <Container className="width-10">
                <h1>Why Lubritect?</h1>
                <h2 style={{textAlign:'center', padding:"10px"}}>Sexual health concerns all of us. None of us would be there without it.</h2>
            <Accordion style={{marginBottom: '32px'}}>
                <Accordion.Item eventKey={String(0)}>
            <Accordion.Header>{flyers[0].header}</Accordion.Header>
            <Accordion.Body>
            <HPControlledCarousel />
                                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey={String(1)}>
            <Accordion.Header>{flyers[1].header}</Accordion.Header>
            <Accordion.Body>
            <Image  style={{width: 'auto', maxHeight: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '250px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/experiences-of-sexual-health.jpg'} text="Second slide" />

                                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey={String(2)}>
            <Accordion.Header>{flyers[2].header}</Accordion.Header>
            <Accordion.Body>
            <Image  style={{width: 'auto', maxHeight: '550px', overflow: 'hidden', objectFit: 'cover', marginLeft: '250px'}}   fluid  src={'https://static.igem.wiki/teams/4602/wiki/images/other-igem-teams.jpg'} text="Second slide" />

                                </Accordion.Body>
            </Accordion.Item>
            </Accordion>
            </Container>
            {textBlocksComponent.map((block, index) => (
            <TextBlockComponent block={block} component={<block.text/>}/>
            ))}
            <Tabs
                defaultActiveKey="human"
                id="uncontrolled-tab-example"
                justify
                > 
                        <Tab eventKey="human" title={<span style={{fontWeight: 'bold'}}>Societal Approaches</span>}>
                        <FlowChart side={"left"}/>
                    </Tab>
                        <Tab eventKey="science" title={<span style={{fontWeight: 'bold'}}>Scientific Approaches</span>} >
                        <FlowChart side={"right"}/>
                    </Tab>
            </Tabs>
            <h2 id="design-principles-from-hp" style={{marginTop: '53px', marginLeft: '53px'}}>Design Principles from Human Practices</h2>
            <DesignPrinciplesHumanPractices/>

            <DesignPrinciples/>

        </div>
)
}
export default Integrated;
